var _defs, _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack170({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5,12A3,3,0,1,0,8,9a3,3,0,1,1,3-3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8,
    y1: 1,
    x2: 8,
    y2: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack170);
export default __webpack_public_path__ + "static/media/Symbolpack_1_70.e2a29ef266509c450b8b7b601709b61c.svg";
export { ForwardRef as ReactComponent };